import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './_layout/layout.component';
import { ListInsuranceComponent } from './list-insurance/list-insurance.component';
import { ListDocumentsComponent } from './list-documents/list-documents.component';
import { ListEstatementsComponent } from './list-estatements/list-estatements.component';
import { ListRequestComponent } from './list-request/list-request.component';
import { PaymentsComponent } from './payments/payments.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { HomepageComponent } from './homepage/homepage.component';
import { ListDocumentsFormsComponent } from './list-documents-forms/list-documents-forms.component';
import { ListClaimsComponent } from './list-claims/list-claims.component';
import { ContactsComponent } from './contacts/contacts.component';
import { QuoteslifeComponent } from './quoteslife/quoteslife.component';
import { CreateClaimComponent } from './create-claim/create-claim.component';
import { RequestComponent } from './request/request.component';
import { SendPolicyDocumentsComponent } from './send-policy-documents/send-policy-documents.component';
import { QuotesComponent } from './quotes/quotes.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'home', 
        component: HomepageComponent
      },
      {
        path: 'contacts', 
        component: ContactsComponent
      },
      {
        path: 'list-insurance', 
        component: ListInsuranceComponent
      },
      {
        path: 'list-documents', 
        component: ListDocumentsComponent
      },
      {
        path: 'list-documents-form', 
        component: ListDocumentsFormsComponent
      },
      {
        path: 'request', 
        component: RequestComponent
      },
      {
        path: 'list-estatements', 
        component: ListEstatementsComponent
      },
      {
        path: 'payments', 
        component: PaymentsComponent
      },
      {
        path: 'myprofile', 
        component: MyProfileComponent
      },
      {
        path: 'quotes-life', 
        component: QuoteslifeComponent,
      },
      {
        path: 'quotes-life-cz', 
        component: QuoteslifeComponent
      },
      {
        path: 'quotes', 
        component: QuotesComponent,
      },
      {
        path: 'create-claim', 
        component: CreateClaimComponent
      },
      {
        path: 'list-claims', 
        component: ListClaimsComponent
      },
      {
        path: 'send-policy-documents', 
        component: SendPolicyDocumentsComponent
      },
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: 'error/404',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
